module.exports = __webpack_public_path__ + "img/language.f5b006e3.svg";